// extracted by mini-css-extract-plugin
export default {"title":"Slider_title__3Lhw9"};